
/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useEffect, useState} from "react";
import {service as ConservationActionPhaseService } from '../../../Services/ConservationActionPhaseService';
import {service as EnvironmentalBenefitService } from '../../../Services/EnvironmentalBenefitService';
import {service as UnitService } from '../../../Services/UnitService';

export function ModeledUpliftFieldViewer(props) {

    const {Value: value} = props;
    const conservationActionPhaseId = value?.conservationActionPhaseId;
    const environmentalBenefitId = value?.SampleEvent?.environmentalBenefitId ?? value?.environmentalBenefitId;
    const recordedBenefitValue = value?.SampleEvent?.benefitValue ?? value?.benefitValue;
    const originalConditions = value?.SampleEvent?.originalConditions ?? value?.originalConditions;
    const targetConditions = value?.SampleEvent?.targetConditions ?? value?.targetConditions;

    // simplified-EB events entered through conditions carry no computed
    // benefitValue; derive it for display the same way the reporting view does
    // (values may be recorded as sanitized strings, hence Number())
    const derivedBenefitValue = (originalConditions != null && targetConditions != null)
        ? Number(originalConditions) - Number(targetConditions)
        : null;
    const benefitValue = recordedBenefitValue ??
        (Number.isFinite(derivedBenefitValue) ? derivedBenefitValue : null);
    
    const [unit, setUnit] = useState(null);
    const [phase, setPhase] = useState(null);
    const [environmentalBenefit, setEnvironmentalBenefit] = useState(null);
    
    const unitId = environmentalBenefit?.unitId;
    
    useEffect(() => {
        if(environmentalBenefitId) {
            EnvironmentalBenefitService.FindById(environmentalBenefitId)
                .then(
                    (r) => setEnvironmentalBenefit(r.result)
                );
        }
    }, [environmentalBenefitId]);

    useEffect(() => {
        if (conservationActionPhaseId) {
            ConservationActionPhaseService.FindById(conservationActionPhaseId)
                .then(
                    (r) => setPhase(r.result)
                );
        }
    }, [conservationActionPhaseId]);
    
    useEffect(() => {
        if(unitId) {
            UnitService.FindById(unitId)
                .then(
                    (r) => {
                        setUnit(r.result);
                    }
                )
                .catch((r) => console.log(r));
        }
    }, [unitId]);
    
    if((unitId && !unit) || (conservationActionPhaseId && !phase) || (environmentalBenefitId && !environmentalBenefit)) {
        return <div>Loading...</div>;
    }
    
    // benefitValue of 0 is a real value; only null/undefined means there is nothing to show
    if(benefitValue == null || !environmentalBenefit) {
        return <div>Details unavailable.</div>;
    }
    
    return <div>
        {benefitValue} {unit?.abbreviation ?? 'units'} of {environmentalBenefit?.name ?? 'Modeled Uplift'} ({phase?.name ?? 'Unknown'} Phase)
    </div>

}